import { render, staticRenderFns } from "./TheSortable.vue?vue&type=template&id=0d1680c8&scoped=true"
import script from "./TheSortable.vue?vue&type=script&lang=js"
export * from "./TheSortable.vue?vue&type=script&lang=js"
import style0 from "./TheSortable.vue?vue&type=style&index=0&id=0d1680c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1680c8",
  null
  
)

export default component.exports